const passkey_sign_in = {
    setup_page: {
        title: 'Simplifique seu login',
        subtitle: 'Crie uma chave de acesso',
        description: 'Registre sua chave de acesso usando a biometria do dispositivo, chaves de segurança como a YubiKey ou outros métodos disponíveis.',
    },
    trigger_conditional_ui_failed: 'Falha ao acionar o preenchimento automático com passkey.',
};
export default Object.freeze(passkey_sign_in);
